import { trimOrNull } from '@/utils/StringUtil';

export function required(value: any) {
  if (typeof value === 'string') return !!trimOrNull(value) || 'Requerido';
  else return !!value || 'Requerido';
}
export function email(value: string) {
  // tslint:disable-next-line:max-line-length
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(value) || 'E-mail inválido';
}


